var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"layout",attrs:{"id":"components-layout"}},[_c('Navigation'),_c('Content'),_c('Footer'),_c('a-back-top',{attrs:{"visibility-height":100}},[_c('div',{staticClass:"back-top-button"},[_c('a-icon',{attrs:{"type":"arrow-up"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }